import { createSlice } from "@reduxjs/toolkit";
import {
  getVehicleByID,
  getVehicles,
} from "./vehicleService";

/* -------------------- Status Enum -------------------- */

export const STATUS = {
  IDLE: "idle",
  LOADING: "loading",
  SUCCEEDED: "succeeded",
  FAILED: "failed",
};

/* -------------------- Initial State -------------------- */

const initialState = {
  vehicleList: {
    status: STATUS.IDLE,
    error: null,
    data: [],
  },
   vehicleDetails: {
    status: STATUS.IDLE,
    error: null,
    data: null,
  },
};

/* -------------------- Slice -------------------- */

const vehicleSlice = createSlice({
  name: "vehicle",
  initialState,
  reducers: {},
  extraReducers: (builder) => {

    /* ---------- Get Vehicle List ---------- */
    builder
      .addCase(getVehicles.pending, (state) => {
        state.vehicleList.status = STATUS.LOADING;
        state.vehicleList.error = null;
      })
      .addCase(getVehicles.fulfilled, (state, action) => {
        state.vehicleList.status = STATUS.SUCCEEDED;
        state.vehicleList.data = action?.payload?.data || [];
      })
      .addCase(getVehicles.rejected, (state, action) => {
        state.vehicleList.status = STATUS.FAILED;
        state.vehicleList.error = action.payload?.message;
      });

       /* ---------- Get Vehicle ---------- */
    builder
      .addCase(getVehicleByID.pending, (state) => {
        state.vehicleDetails.status = STATUS.LOADING;
        state.vehicleDetails.error = null;
      })
      .addCase(getVehicleByID.fulfilled, (state, action) => {
        state.vehicleDetails.status = STATUS.SUCCEEDED;
        state.vehicleDetails.data = action?.payload;
      })
      .addCase(getVehicleByID.rejected, (state, action) => {
        state.vehicleDetails.status = STATUS.FAILED;
        state.vehicleDetails.error = action.payload?.message;
      });

  },
});

/* -------------------- Selectors -------------------- */

export const selectVehicleList = (state) =>
  state.vehicle.vehicleList;

export const selectVehicle = (state) =>
  state.vehicle.vehicleDetails;

export default vehicleSlice.reducer;
